if(!customElements.get('variant-swatch-selector')){
    class VariantSwatchSelector extends HTMLElement {
        constructor(){
            super();

            this.section = this.closest('.section-product-cards');
            this.inputs = this.querySelectorAll('.product-card__input');
        }

        connectedCallback(){
            this.inputs.forEach(item => {
                const groupRadios = item.querySelectorAll('input[type="radio"]');
                groupRadios.forEach(radio => {
                    radio.addEventListener("change", (e) => {
                        const selectedOption = item.querySelector('input[type="radio"]:checked');
                        const data = {
                            event: e,
                            target: selectedOption,
                            selectedOptionValues: this.selectedOptionValues
                        }
                        this.updateValue(data);
                    });

                    const label = this.querySelector(`label[for="${radio.id}"]`);
                    if(label){
                        label.addEventListener("keydown", e => {
                            if(e.key === 'Enter'){
                                radio.checked = true;
                                const selectedOption = item.querySelector('input[type="radio"]:checked');
                                const data = {
                                    event: e,
                                    target: selectedOption,
                                    selectedOptionValues: this.selectedOptionValues
                                }
                                this.updateValue(data);
                            }
                        })
                    }
                });
            });
        }

        updateValue(data = {event: null, target: null, selectedOptionValues: null, source: null}){
            PubSub.publish(PubSub.events.productCardSwatchValueChange, {
                data: data
            });
        }

        get selectedOptionValues() {
            return Array.from(this.querySelectorAll('fieldset input:checked')).map(
                ({ dataset }) => dataset.optionValueId
            );
        }
    }

    customElements.define('variant-swatch-selector', VariantSwatchSelector);
}